var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup3783(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "gray",
    width: 28.707,
    height: 26.706,
    viewBox: "0 0 28.707 26.706",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3783",
    "data-name": "Group 3783",
    transform: "translate(435.344 -119.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4042",
    "data-name": "Path 4042",
    d: "M-431.927,142.387v-.45q0-9.338,0-18.676a3.411,3.411,0,0,1,3.522-3.519q9.141,0,18.283,0a3.38,3.38,0,0,1,3.408,2.723,3.312,3.312,0,0,1,.077.582c.021.468-.284.75-.811.751-1.442,0-2.883,0-4.325,0-.36,0-.361,0-.361.368q0,9.408,0,18.816a3.386,3.386,0,0,1-3.436,3.459q-8.2.007-16.4,0a3.375,3.375,0,0,1-3.335-3c-.005-.046-.013-.093-.021-.139a.714.714,0,0,1,.764-.918c.758-.008,1.516,0,2.275,0Zm1.312,0h11.979a2.663,2.663,0,0,1,.392.014.645.645,0,0,1,.612.675,2.8,2.8,0,0,0,.088.523,2.092,2.092,0,0,0,2.313,1.526,2.1,2.1,0,0,0,1.785-2.091q0-9.87,0-19.74a3.593,3.593,0,0,1,.58-2.043,1.216,1.216,0,0,0,.081-.2h-.338c-5.1,0-10.2.014-15.3-.011a2.184,2.184,0,0,0-2.2,2.216c.02,6.262.009,12.523.01,18.785Zm12.316,2.731a9.224,9.224,0,0,1-.472-1.08.411.411,0,0,0-.483-.35q-7.173.014-14.346.007h-.27a.519.519,0,0,0-.005.123.8.8,0,0,0,.059.156A1.979,1.979,0,0,0-432,145.129q6.724.016,13.448,0C-418.469,145.134-418.388,145.125-418.3,145.119Zm6.332-22.649h3.852a1.982,1.982,0,0,0-2.016-1.418A1.96,1.96,0,0,0-411.967,122.47Z",
    transform: "translate(0 0)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4043",
    "data-name": "Path 4043",
    d: "M-195.059,332.731c0-.617.008-1.235-.005-1.852a1.162,1.162,0,0,0-.115-.478,4.046,4.046,0,0,1,2.715-5.8,4.032,4.032,0,0,1,4.845,3.179,4.069,4.069,0,0,1-.376,2.639,1.107,1.107,0,0,0-.116.478c-.009,1.225,0,2.451-.005,3.676a.727.727,0,0,1-1.159.685q-1.035-.56-2.057-1.143a.429.429,0,0,0-.487,0c-.664.382-1.34.742-2.008,1.118a.922.922,0,0,1-.777.106.631.631,0,0,1-.453-.636C-195.062,334.04-195.059,333.385-195.059,332.731Zm3.472-6.913a2.733,2.733,0,0,0-2.731,2.66,2.745,2.745,0,0,0,2.713,2.807,2.744,2.744,0,0,0,2.765-2.761A2.7,2.7,0,0,0-191.587,325.817Zm.3,6.838,1.853,1.025v-1.62Zm-.6,0-1.838-.6v1.615Z",
    transform: "translate(-226.253 -193.249)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4044",
    "data-name": "Path 4044",
    d: "M-311.9,294.055q-2.99,0-5.979,0a.7.7,0,0,1-.67-.374.586.586,0,0,1,.054-.659.721.721,0,0,1,.637-.283q4.506.005,9.011,0h2.976a.67.67,0,0,1,.753.651.669.669,0,0,1-.746.66Q-308.887,294.056-311.9,294.055Z",
    transform: "translate(-110.157 -163.281)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4045",
    "data-name": "Path 4045",
    d: "M-311.866,212.615q-3.031,0-6.062,0a.652.652,0,0,1-.671-.519.633.633,0,0,1,.358-.694,1.324,1.324,0,0,1,.464-.069c.7-.007,1.4,0,2.1,0q4.855,0,9.711.006a1.348,1.348,0,0,1,.517.078.622.622,0,0,1,.331.706.642.642,0,0,1-.661.495Q-308.821,212.616-311.866,212.615Z",
    transform: "translate(-110.176 -86.441)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4046",
    "data-name": "Path 4046",
    d: "M-315.323,457.194c-.833,0-1.666,0-2.5,0a.652.652,0,0,1-.712-.6.668.668,0,0,1,.649-.7,1.991,1.991,0,0,1,.224,0q2.316,0,4.632,0a1.762,1.762,0,0,1,.388.04.613.613,0,0,1,.478.715.607.607,0,0,1-.606.548C-313.62,457.2-314.472,457.194-315.323,457.194Z",
    transform: "translate(-110.247 -317.263)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4047",
    "data-name": "Path 4047",
    d: "M-315.383,374.634c.823,0,1.646,0,2.469,0a.616.616,0,0,1,.7.625.6.6,0,0,1-.668.654q-2.511.011-5.022,0a.637.637,0,0,1-.68-.54.634.634,0,0,1,.378-.683.963.963,0,0,1,.353-.055C-317.03,374.631-316.207,374.633-315.383,374.634Z",
    transform: "translate(-110.194 -240.573)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4048",
    "data-name": "Path 4048",
    d: "M-156.891,369.213c.08-.111.142-.19.2-.274.283-.429.556-.865.849-1.288a.659.659,0,0,1,.871-.194.619.619,0,0,1,.231.853c-.521.832-1.056,1.655-1.612,2.464a.6.6,0,0,1-.974.024c-.426-.532-.831-1.084-1.22-1.644a.607.607,0,0,1,.164-.846.623.623,0,0,1,.878.108C-157.3,368.662-157.11,368.928-156.891,369.213Z",
    transform: "translate(-261.146 -233.717)",
    fill: "gray"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3783);
export default __webpack_public_path__ + "static/media/Group 3783.8cda71f199f6dc8d693674b15047ab55.svg";
export { ForwardRef as ReactComponent };